import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { VAGUE_ROOT_ID } from "../common/list-query";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
/**
 * Drive 文件生成副本.
 */
export var FileCloneRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(FileCloneRequest, _DriveRequest);
  var _super = _createSuper(FileCloneRequest);
  function FileCloneRequest() {
    _classCallCheck(this, FileCloneRequest);
    return _super.apply(this, arguments);
  }
  _createClass(FileCloneRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: "/v2/file/clone?xsrf=".concat(getXsrfToken()),
        data: {
          file_id: params.id,
          parent_id: params.folderId === VAGUE_ROOT_ID ? '' : params.folderId,
          title: params.title
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'FileCloneResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return response.result;
    }
  }]);
  return FileCloneRequest;
}(DriveRequest);
//# sourceMappingURL=file-clone.js.map